<template>
    <div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <notification :show="showNotification" :errors="errors"></notification>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-1"></div>
            <div class="col-lg-10">
                <table class="table table-striped table-sm">
                    <thead class="bg-primary text-white">
                    <tr>
                        <th>
                            Dátum
                        </th>
                        <th>
                            Felhasználó
                        </th>
                        <th>
                            Esemény
                        </th>
                        <th>
                            Sorozatszám
                        </th>
                        <th>
                            Összeg
                        </th>
                        <th>
                            Státusz
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="event in worksheetEvents">
                        <td>
                            {{ formattedDate(event.time) }}
                        </td>
                        <td>
                            {{ event.username }}
                        </td>
                        <td>
                            {{ event.event }}
                        </td>
                        <td>
                            {{ event.serialnumber }}
                        </td>
                        <td>
                            {{ event.price }}
                        </td>
                        <td>
                            {{ event.status }}
                        </td>
                    </tr>
                    <tr style="background: #fff">
                        <td>
                            <v-date-picker
                                mode='single'
                                v-model='event.time'
                                style="width: 100%"
                                popover-direction="top"
                            >
                                <input slot-scope='props'
                                       id="record-time"
                                       type="text"
                                       class="form-control form-control-sm"
                                       :value="props.inputValue"
                                       @change='props.updateValue($event.target.value)'
                                >
                            </v-date-picker>
                        </td>
                        <td>
                            <v-select
                                id="user"
                                :options="users"
                                v-model="user"
                                single
                            >
                                <div slot="no-options">Nincs a keresésnek megfelelő találat.</div>
                            </v-select>
                        </td>
                        <td>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="event"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="event.event"
                                >
                            </div>
                        </td>
                        <td>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="serialnumber"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="event.serialnumber"
                                >
                            </div>
                        </td>
                        <td>
                            <div class="input-group mb-2 mr-sm-2 mb-sm-0">
                                <input
                                    id="prize"
                                    type="text"
                                    class="form-control form-control-sm"
                                    v-model="event.prize"
                                >
                            </div>
                        </td>
                        <td>
                            <v-select
                                id="record-status"
                                :options="statusOptions"
                                v-model="event.status"
                                taggable
                                push-tags
                            >
                                <div slot="no-options">Új státusz megadásához gépelje be, majd üssön ENTER-t.</div>
                            </v-select>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-lg-1"></div>
            <div class="col-lg-3 col-xl-1">
                <button type="submit" class="btn btn-primary btn-block" @click.prevent="save" :disabled="isLoading">
                    <i v-if="isLoading" class="fa fa-spin fa-refresh"></i>
                    <i v-else class="fa fa-save"></i>
                    Mentés
                </button>
            </div>
            <div class="col-lg-3 col-xl-1">
                <button type="submit" class="btn btn-primary btn-block" @click.prevent="$router.back()"
                        :disabled="isLoading">
                    Vissza
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import Notification from './Notification';

    export default{
        name: 'Events',
        data(){
            return {
                event: {
                    time: new Date(),
                    userId: null,
                    event: null,
                    serialnumber: null,
                    prize: null,
                    status: null
                },
                user: null,
                showNotification: false
            }
        },
        props: {
            worksheetEvents: {
                type: Array,
                required: true
            },
            users: {
                type: Array,
                required: true
            },
            statusOptions: {
                type: Array,
                required: true
            }
        },
        computed: {
            isLoading(){
                return this.$store.state.WorksheetModul.saveEventLoading;
            },
            errors(){
                return this.$store.state.WorksheetModul.saveEventError;
            }
        },
        watch: {
            user(){
                if(this.user !== null){
                    this.event.userId = this.user.value;
                }
            }
        },
        methods: {
            formattedDate(dateString){
                let date = new Date(dateString);
                let year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();

                if(month < 10){
                    month = '0' + month;
                }
                if(day < 10){
                    day = '0' + day;
                }

                return `${year}. ${month}. ${day}.`;
            },
            save(){
                this.showNotification = false;
                this.$store.dispatch('WorksheetModul/saveWorksheetEvent', {
                    data: {
                        worksheetId: this.$route.params.id,
                        event: this.event
                    },
                    result: (res) => {
                        this.showNotification = true;
                        this.resetData();
                        this.$emit('reload');
                    },
                    reject: (rej) => {
                        this.showNotification = true;
                        console.error(rej);
                        window.scrollTo(0,0)
                    }
                })
            },
            resetData(){
                this.event = {
                    time: new Date(),
                    userId: null,
                    event: null,
                    serialnumber: null,
                    prize: null,
                    status: null
                };
                this.user = null;
            }
        },
        components: {
            Notification
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/worksheet/Events.vue